export enum EStatusContraNota {
  Todos = 1,
  Manifestado = 2,
  NaoManifestado = 3,
  Importado = 4,
  NaoImportado = 5,
  Cancelado = 6,
}
